import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'

const service = axios.create({
  baseURL: 'https://xyxapi.dayujh.cn',
  timeout: 15000
})

let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.3)'
    })

    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    if (loadingInstance) loadingInstance.close()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (loadingInstance) loadingInstance.close()

    const res = response.data

    // 后端统一响应格式：{ code, msg, data }
    if (res.code !== 0 && res.code !== undefined) {
      Message.error(res.msg || '请求失败')

      // Token 失效处理
      if (res.code === 401) {
        removeToken()
        router.push('/login')
      }

      return Promise.reject(new Error(res.msg || 'Error'))
    }

    return res.data
  },
  error => {
    if (loadingInstance) loadingInstance.close()

    const res = error.response && error.response.data
    if (res && res.msg) {
      Message.error(res.msg)
      if (res.code === 401) {
        removeToken()
        router.push('/login')
      }
    } else {
      Message.error(error.message || '网络错误')
    }

    return Promise.reject(error)
  }
)

export default service
